import React from "react";
import { Link } from "react-router-dom";
import "./members.css";

export const OneMember = (props) => {
  return (
    <div className="big-box container">
      <div className="heading">
        <h1>{props.heading}</h1>
      </div>
      <div className="medium-box">
        {props.Name.map((Name, index) => {
          return (
            <div className="small-box-1">
              <div className="small-box-img">
                <img src={props.Pic[index]} alt="avatar"/>
              </div>
              <div className="small-box-personal-details">
                  <h4 style={{ fontWeight: "bold" }}>{props.Name[index]}</h4>
                  {props.Info[index].map((info, index1) => {
                    return <h4>{props.Info[index][index1]}</h4>;
                  })}
                  {props.Link_name[index].map((Link_name, index2) => {
                    return (
                      <h4>
                        Web page:{" "}
                        <Link to={props.P_website[index][index2]}>
                          {props.Link_name[index][index2]}
                        </Link>
                      </h4>
                    );
                  })}
              </div>
              {props.Bio[index].map((bio, index3) => {
                return (
                  <div className="small-box-bio">
                    <p>
                      {props.Bio[index][index3]}
                    </p>
                  </div>
                );
              })}
              <hr className="hr-style" />
            </div>
          );
        })}
      </div>
    </div>
  );
};
